"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import { ImageGalleryCarousel } from "@/components/ui/image-gallery-carousel";
import { ImageLightbox, type LightboxImage } from "@/components/ui/image-lightbox";

type ImageGalleryWithLightboxProps = {
  images: LightboxImage[];
  title: string;
  priorityFirstImage?: boolean;
};

export const ImageGalleryWithLightbox = ({
  images,
  title,
  priorityFirstImage = false,
}: ImageGalleryWithLightboxProps) => {
  const t = useTranslations("galleryPage");
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  return (
    <>
      <ImageGalleryCarousel
        images={images}
        title={title}
        onImageClick={setLightboxIndex}
        previousLabel={t("carousel.previous")}
        nextLabel={t("carousel.next")}
        priorityFirstImage={priorityFirstImage}
      />
      <ImageLightbox
        images={images}
        initialIndex={lightboxIndex ?? 0}
        isOpen={lightboxIndex !== null}
        onClose={() => setLightboxIndex(null)}
        closeLabel={t("lightbox.close")}
        previousLabel={t("lightbox.previous")}
        nextLabel={t("lightbox.next")}
        countLabel={(current, total) => t("lightbox.count", { current, total })}
      />
    </>
  );
};
